import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'
import update from 'immutability-helper'

const initialState = {
  checklists: []
}

const leadReducer = createReducer(initialState, {
  [ACT.LEAD_CHECKLISTS_FETCH_SUCCESS](state, action) {
    const { checklists } = action.payload

    return update(state, {
      checklists: { $set: checklists }
    })
  },

  [ACT.CREATE_LEAD_CHECKLIST_SUCCESS](state, action) {
    const { checklist } = action.payload

    return update(state, {
      checklists: { $push: [checklist] }
    })
  },

  [ACT.UPDATE_LEAD_CHECKLIST_SUCCESS](state, action) {
    const { checklist } = action.payload
    const index = state.checklists.findIndex(c => c.id === checklist.id)

    return update(state, {
      checklists: {
        [index]: {
          $set: { ...checklist }
        }
      }
    })
  },

  [ACT.ADD_LEAD_CHECKLIST_ITEM_SUCCESS](state, action) {
    const { item, checklistId } = action.payload
    const index = state.checklists.findIndex(checklist => checklist.id === checklistId)

    return update(state, {
      checklists: {
        [index]: {
          items: { $push: [item] }
        }
      }
    })
  },

  [ACT.LEAD_CHECKLIST_TOGGLE_ITEM_COMPLETED_SUCCESS](state, action) {
    const { item, checklistId } = action.payload
    const checklistIndex = state.checklists.findIndex(checklist => checklist.id === checklistId)
    const itemIndex = state.checklists[checklistIndex].items.findIndex(i => i.id === item.id)

    return update(state, {
      checklists: {
        [checklistIndex]: {
          items: {
            [itemIndex]: { $set: item }
          }
        }
      }
    })
  },

  [ACT.DELETE_LEAD_CHECKLIST_ITEM_SUCCESS](state, action) {
    const { checklistId, itemId } = action.payload
    const checklistIndex = state.checklists.findIndex(checklist => checklist.id === checklistId)
    const itemIndex = state.checklists[checklistIndex].items.findIndex(i => i.id === itemId)

    return update(state, {
      checklists: {
        [checklistIndex]: {
          items: {
            $splice: [[itemIndex, 1]]
          }
        }
      }
    })
  },

  [ACT.DELETE_LEAD_CHECKLIST_SUCCESS](state, action) {
    const { checklistId } = action.payload
    const checklistIndex = state.checklists.findIndex(checklist => checklist.id === checklistId)

    return update(state, {
      checklists: {
        $splice: [[checklistIndex, 1]]
      }
    })
  }
})

export default leadReducer
